export var SIDEBAR_ANIMATION_DURATION = 475; // ms taken from semantic ui